import { useEffect, useState } from "react";
import { createAuthenticatedClient } from "../utils/apiClient";
import { getStoredToken } from "../utils/installAuthToken";

const PARTIES_API = "https://directory.poc.mrc.ai/api/parties";

// Directory role codes that make a party a carrier
export const CARRIER_ROLE_CODES = ["Insurer", "Reinsurer"];

const useParties = (load) => {
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    load(createAuthenticatedClient(getStoredToken()))
      .then((list) => !cancelled && setParties(list))
      .catch((err) => !cancelled && setError(err))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
    // load is fixed per hook below
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { parties, loading, error };
};

const asArray = (data) => (Array.isArray(data) ? data : []);

/** Every carrier party (Insurer or Reinsurer), sorted by name. */
export const useCarrierParties = () =>
  useParties(async (client) => {
    const lists = await Promise.all(
      CARRIER_ROLE_CODES.map(async (role) =>
        asArray((await client.get(`${PARTIES_API}?roleCode=${encodeURIComponent(role)}`)).data)
      )
    );
    const byId = new Map(lists.flat().map((p) => [p._id, p]));
    return [...byId.values()].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
  });

/** The Directory parties the signed-in user acts for. */
export const useMyParties = () =>
  useParties(async (client) => asArray((await client.get(`${PARTIES_API}/mine`)).data));
